import React, { useState } from 'react';
import { Modal } from '../Modal';
import Portal from '../Portal';

const RSSCard = (props) => {

    let className = `card post rss-item ${props.className}`;
    
    const [openModal, setOpenModal] = useState(false);
    // this.htmlBody = document.querySelector('body')
    // this.htmlBodyContentSelector = 'body'

    const handleCardClick = (e) => {
        if(props.modal !== true) return;

        e.preventDefault();
        setOpenModal(true);
    }
    let embed = '';
    if(props.modal === true) {
        
        
        if(props.link.indexOf('youtube') > -1) { 
            embed = "https://www.youtube.com/embed/"+props['yt:videoId'];
        }
        if(props.link.indexOf('vimeo') > -1) {
            embed = props.oembed;
            if(!props.oembed) {
                // https://vimeo.com/464747728 THE LINK
                // https://player.vimeo.com/video/464747728 THE EMBED

                // Move to the Player embed
                if(props.link.indexOf('https://vimeo.com/') > -1){
                    let link = 'https://player.vimeo.com/video/';
                    let parts = props.link.split('https://vimeo.com/');
                    if(parts.length == 2){
                        embed = link + parts[1]
                    }
                }
            }
        }

    }


    return (
        <article className={className}>

            <a href={props.link} target="_blank" onClick={handleCardClick}>

                <div className="image">

                    <img src={props.image} />

                </div>

            </a>

            <div className="content">

                <a href={props.link} target="_blank" onClick={handleCardClick}>

                    <h6 dangerouslySetInnerHTML={{__html: props.title}}></h6>

                </a>

            </div>

            {props.modal === true && (
                <Portal selector='body' insertBefore="true">
                    <Modal open={openModal} onClose={() => setOpenModal(false)} className="-centered">
                        {openModal && (<div className="embed-container">
                            <iframe width="928" height="522" src={embed} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        </div>)}
                    </Modal>
                </Portal>
            )}

        </article>
    );

}

export default RSSCard;